import React from 'react';
import './Table.css'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { post } from '../../service/index.js'
import swal from 'sweetalert'

function _SubConferenceTable({ subCF, onDelete, marginTop, token }) {

    let meeting = subCF;

    const handleOnDragEnd = (result) => {
        if (!result.destination) return;

        const items = Array.from(meeting);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);

        meeting = items;
        // console.log("items", items);

        edit_position(items);

    }

    const edit_position = async (items) => {

        // console.log("items in edit_position", items);

        items.forEach(async (element, index) => {
            try {
                // console.log(element)
                // console.log("element sub", element.sub_id)
                // console.log("index", index);
                if (items.length !== 0) {

                    const result = await post('/edit_position_sub_conference', { id: element.sub_id ? element.sub_id : element.id, position: index + 1 }, token)

                }
            } catch (err) {
                console.log(err)
                swal('ไม่สามารถแก้ไขลำดับการประชุมได้', '', 'error')
            }
        });

    }

    return (
        <div className='table-container' style={{ marginTop }} >
            <div className='table-title-container' >
                <div><p>วาระการประชุม</p></div>
                <div><p>วันที่ประชุม</p></div>
                <div><p>เวลาประชุม</p></div>
                <div><p>ไฟล์เอกสาร</p></div>
            </div>
            <DragDropContext onDragEnd={handleOnDragEnd}>
                <Droppable droppableId="meeting">
                    {(provided) => (
                        <div className="meeting" {...provided.droppableProps} ref={provided.innerRef}>
                            {
                                subCF.length > 0 ?
                                    meeting.map((el, index) => {
                                        return el.status !== 1 ? (
                                            <Draggable key={el.title} draggableId={el.title} index={index}>
                                                {(provided) => (
                                                    <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} className={index % 2 === 0 ? 'table-content' : 'table-content even'}>
                                                        <div className='table-title-name' title={el.title} >{el.hasOwnProperty("title") ? el.title.length > 8 ? el.title.slice(0, 9) + '...' : el.title : ""}</div>
                                                        <div className='table-date'>{el.meeting_time.replace("T", " ").split(" ")[0]}</div>
                                                        <div className='table-date'>{el.meeting_time.replace("T", " ").split(" ")[1].slice(0, 5) + ' น.'}</div>
                                                        <div className='table-file-name' title={el.pdf.name} >{el.pdf.name ? el.pdf.name.length > 8 ? el.pdf.name.slice(0, 9) + '...' : el.pdf.name : ''}</div>
                                                        <img
                                                            className="delete-user-row"
                                                            src={require("../../assets/icon/cancel.png")}
                                                            alt="cancel"
                                                            onClick={onDelete(index)}
                                                        />
                                                    </div>
                                                )}
                                            </Draggable>
                                        ) : null
                                    }) : null
                            }
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
            {Array.from(new Array(6), (el, index) => (
                true ?
                    <div key={index} className={index % 2 === 1 ? 'table-content' : 'table-content even'} /> :
                    <div key={index} className={index % 2 === 0 ? 'table-content' : 'table-content even'} />
            ))}
        </div>
    )

}
export default _SubConferenceTable;


// WEBPACK FOOTER //
// ./src/components/Table/SubConferenceTable.js